























import AbpBase from "../../../lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetDicTemps,GetDicTempsByType,SaveDicTemp} from '../../../api/systemBasic'
import util from '../../../lib/util'
import model from './model.vue'

@Component({
    components:{model}
})
export default class  extends AbpBase{
    QueryString = ''
    list:any = []
    detailList:any = []
    table:any = {
        loading:false,
        detailLoading:false
    }
    modelShow = false
    modelData:any = {}
    detailInfo:any = {}
    //表格高度
    get tableHeight(){
        return window.innerHeight-200
    }
    created(){
        this.getData()
    }
    async getData(){
        this.table.loading = true
        let res = await GetDicTemps({QueryString:this.QueryString})
        this.list  = res.objects
        this.table.loading = false
        //默认选择第一条
        this.list[0]._highlight = true;
        this.detailInfo = this.list[0]
        this.getDetail(this.list[0].type)
    }
    async getDetail(type:any){
        let res = await GetDicTempsByType({type:type})
        this.detailList = res.objects;
    }
     //tab选择
    tabChange(currentRow:any,oldCurrentRow:any){
        if(currentRow){
            this.detailInfo = currentRow
            this.getDetail(currentRow.type)
        }
    }
    add(){
        this.modelData.title = '新增'
        this.modelData.info = this.detailInfo
        this.modelData.row = {}
        this.modelShow = true
    }
    async default(row:any){
        row.iseDefault = true
        let res = await SaveDicTemp(row)
        if(res.status == 1){
            this.getDetail(this.detailInfo.type)
        }
        
    }
    async remove(row:any){
        row.status = !row.status
        let res = await SaveDicTemp(row)
        if(res.status == 1){
            this.getDetail(this.detailInfo.type)
        }
    }
    edit(row:any){
        this.modelData.title = '编辑'
        this.modelData.info = this.detailInfo
        this.modelData.row = row
        this.modelShow = true
    }
    column = [
        {
            title:'名称',
            key:'typeDesc'
        }
    ]
    detailColumn = [
        {
            title:'标题',
            key:'title',
        },
        {
            title:'内容',
            key:'content',
        },
        {
            title:'排序',
            key:'orderBy',
        },
        {
            title:'操作',
            render :(h:any,params:any) => {
                let isdefaultDom;
                if(!params.row.iseDefault){
                    isdefaultDom = h('Button',{
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style:{
                            marginRight:'15px',
                            width:'120px'
                        },
                        on: {
                            click: () => {
                                this.default(params.row)
                            }
                        }
                    },'设为默认')
                }else{
                    isdefaultDom = h('Button',{
                        props: {
                            type: 'text',
                            size: 'small',
                            icon:'md-checkbox'
                        },
                        style:{
                            marginRight:'15px',
                            width:'120px'
                        },
                    },'当前默认')
                }

                return h('div',[
                    isdefaultDom,
                    h('Button',{
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style:{
                            marginRight:'15px'
                        },
                        on: {
                            click: () => {
                                this.edit(params.row)
                            }
                        }
                    },'编辑'),
                    h('Button',{
                        props: {
                            type: params.row.status?'error':'primary',
                            size: 'small'
                        },
                        style:{
                            marginRight:'15px'
                        },
                        on: {
                            click: () => {
                                this.remove(params.row)
                            }
                        }
                    },params.row.status?'禁用':'启用')
                ])
            },
        }
    ]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tempManage/system/index.vue